// shared the game colours; apps apply them once on the root element
export const GAME_DESIGN = {
  amber: '#f6b83d',
  orange: '#e68728',
  ink: '#1d2433',
  surface: '#ffffff',
  border: '#e4e7ec',
};
export function applyDesignTokens(element: HTMLElement) {
  const tokens: Record<string, string> = {
    '--primary': GAME_DESIGN.amber,
    '--foreground': GAME_DESIGN.ink,
    '--game-orange': GAME_DESIGN.orange,
    '--card': GAME_DESIGN.surface,
    '--border': GAME_DESIGN.border,
  };
  for (const [name, value] of Object.entries(tokens)) element.style.setProperty(name, value);
}
